import { Modal } from 'bootstrap';

function initializeSymptomChecker(): void {
  const modalElement = document.getElementById("symptomCheckerModal") as HTMLElement;
  if (!modalElement) return;
  const modalComponent = new Modal(modalElement);
  modalComponent.show();  
}


document.addEventListener('DOMContentLoaded', () => {
  initializeSymptomChecker();
});
